export const PLATFORM = {
  mobileWeb: 'MobileWeb',
  webDesktop: 'WebDesktop'
}

export const RESURRECTION_PATH_COOKIE_NAME = 'cu_resu_lp'
export const IMPERSONATION_COOKIE_NAME = 'impersonationToken'
export const TRACK_UUID_COOKIE_NAME = '@CU/TrackUuid'
